import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@app-evolution-cms/element-ui';

import { MenuItem } from './menu-item';

import { MODULE_CLAIM } from '../../users/_constants/module-claim';
import { ROLE_CLAIM } from '../../users/_constants/role-claim';

import { type Claim } from '../../users/_api/request.type';

const MODULES_WITHOUT_CREATE: string[] = [
  MODULE_CLAIM.faqs,
  MODULE_CLAIM.media,
  MODULE_CLAIM.notificationCenterTemplates,
];
const MODULES_WITHOUT_UPDATE: string[] = [
  MODULE_CLAIM.faqs,
  MODULE_CLAIM.featureFlags,
  MODULE_CLAIM.onboardingsplash,
  MODULE_CLAIM.rules,
  MODULE_CLAIM.targetGroups,
];

interface MenuItemWithControlsProps {
  claim: Claim;
  isEditMode: boolean;
  assignedGroupId?: string;
  customGroups: { id: string; label: string }[];
  onAssignToGroup: ({ moduleId, groupId }: { moduleId: string; groupId: string | 'none' }) => void;
}

export function MenuItemWithControls({
  claim,
  isEditMode,
  assignedGroupId,
  customGroups,
  onAssignToGroup,
}: MenuItemWithControlsProps) {
  const {
    module: { id, label },
    role,
  } = claim;

  const hasCreate = !MODULES_WITHOUT_CREATE.includes(id) && role !== ROLE_CLAIM.viewer;
  const hasUpload = !MODULES_WITHOUT_UPDATE.includes(id) && role !== ROLE_CLAIM.viewer;

  return (
    <div key={id} className="relative">
      <MenuItem id={id} label={label} role={role} hasCreate={hasCreate} hasUpload={hasUpload} />

      {isEditMode ? (
        <div className="mt-1 mb-4 pl-2">
          <Select
            value={assignedGroupId ?? 'none'}
            onValueChange={(value) => onAssignToGroup({ moduleId: id, groupId: value })}
          >
            <SelectTrigger size="sm">
              <SelectValue placeholder="Seleccionar sección" />
            </SelectTrigger>
            <SelectContent side="bottom">
              <SelectItem size="sm" value="none">
                Sección predeterminada
              </SelectItem>
              {customGroups.map((group) => (
                <SelectItem key={group.id} size="sm" value={group.id}>
                  {group.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      ) : null}
    </div>
  );
}
